module.exports = __webpack_public_path__ + "media/images/icon__point--gained-f3ff3ecdab579ef3a82bcbb230bbb1de.png";